// ─────────────────────────────────────────────────────────────────────────────
// feeConstants.js
// All static config for the Fee Management module.
// When your backend serves these dynamically, replace each array with an
// API call in feeApi.js and remove the relevant export from here.
// ─────────────────────────────────────────────────────────────────────────────

export const FEE_COMPONENTS = [
  { id: "tuition",     label: "Tuition Fee",     defaultValue: 5000, required: true  },
  { id: "admission",   label: "Admission Fee",   defaultValue: 2000, required: false },
  { id: "sports",      label: "Sports Fee",      defaultValue:  800, required: false },
  { id: "library",     label: "Library Fee",     defaultValue: 1000, required: false },
  { id: "examination", label: "Examination Fee", defaultValue: 1200, required: true  },
  { id: "annual",      label: "Annual Fund",     defaultValue: 1500, required: false },
  { id: "lab",         label: "Lab Fee",         defaultValue:  900, required: false },
  { id: "transport",   label: "Transport Fee",   defaultValue: 2500, required: false },
  { id: "hostel",      label: "Hostel Fee",      defaultValue: 8000, required: false },
  { id: "previous_dues", label: "Previous Dues", defaultValue: 0, required: false },
];

export const FEE_CATEGORIES = [
  { id: "monthly",   label: "Tuition Fee",   prefix: "MON" },
  { id: "exam",      label: "Exam Fee",      prefix: "EXM" },
  { id: "sports",    label: "Sports Fee",    prefix: "SPT" },
  { id: "library",   label: "Library Fee",   prefix: "LIB" },
  { id: "transport", label: "Transport Fee", prefix: "TRN" },
  { id: "hostel",    label: "Hostel Fee",    prefix: "HST" },
  { id: "custom",    label: "Custom Fee",    prefix: "CST" },
];

// Discounts are either a share of the subtotal or a flat rupee amount. There is
// deliberately no full-waiver option: a 100% percentage discount covers it.
export const CONCESSION_TYPES = [
  { id: "percentage", label: "Percentage (%)" },
  { id: "fixed",      label: "Fixed Amount"   },
];

export const ACADEMIC_YEARS = [
  "2023-2024", "2024-2025", "2025-2026", "2026-2027",
];

export const MONTHS = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

export const REPORT_TYPES = [
  { id: "dashboard",    label: "Dashboard Overview"  },
  { id: "collection",   label: "Fee Collection"      },
  { id: "pending",      label: "Pending Fees"        },
  { id: "concession",   label: "Discounts"           },
  { id: "classWise",    label: "Class-wise Analysis" },
  { id: "monthlyTrend", label: "Monthly Trend"       },
];

// ── Printed challan settings ─────────────────────────────────────────────────
// Used by challanDocument.js for the bank-style three-copy challan. The school
// name is only a fallback; the student's campus name is preferred when present.
export const CHALLAN_SCHOOL_NAME = "American Lycetuff School System";
export const CHALLAN_BANK_NAME = process.env.REACT_APP_CHALLAN_BANK_NAME || "Faysal Bank";
export const CHALLAN_BANK_BRANCH =
  process.env.REACT_APP_CHALLAN_BANK_BRANCH || "Contact School Accounts Office";
export const CHALLAN_BANK_IBAN =
  process.env.REACT_APP_CHALLAN_BANK_IBAN || "Contact School Accounts Office";
export const CHALLAN_LATE_FEE = 200;
export const CHALLAN_BANK_GRACE_DAYS = 8;
export const CHALLAN_COPIES = ["Bank Copy", "School Copy", "Student Copy"];

export const TABS = [
  { id: "setup",      label: "Fee Setup"          },
  { id: "management", label: "Fee Management"     },
  { id: "challan",    label: "Challan Generation" },
  { id: "printing",   label: "Challan Printing"   },
  { id: "verify",     label: "Challan Verification" },
  { id: "report",     label: "Reports"            },
];